import { createSlice } from '@reduxjs/toolkit';

export const slotSlice = createSlice({
    name: 'slot',
    initialState: {
        slots: [],
        // Día de la semana (0-6) al que pertenecen los slots cargados. Los calendarios solo
        // pintan los slots si coincide con el día seleccionado: evita que una respuesta que
        // llega tarde (al cambiar de día deprisa) muestre la parrilla de OTRO día con el
        // código de fecha actual y se reserve una plantilla equivocada.
        slotsDayOfWeek: null,
        isLoadingSlots: true,

    },
    reducers: {
        onCheckingSlot: (state) => {

            state.slots = [];
            state.errorMessage = undefined;
        },
        onReserve: (state) => {
            state.status = 'Reservando....';
            state.slots = [];

        },
        onCreateSlot(state, { payload }) {
            state.slots = '';
            //Para que no se agreguen eventos que ya estan en el store



        },
        onLoadSlots(state, { payload = [] }) {

            state.isLoadingEvents = false;
            //console.log("ejecuta onLoadSlots");
            // Acepta { slots, dayOfWeek } o, por compatibilidad, un array de slots.
            if (Array.isArray(payload)) {
                state.slots = payload;
                state.slotsDayOfWeek = null;
            } else {
                state.slots = Array.isArray(payload.slots) ? payload.slots : [];
                state.slotsDayOfWeek = payload.dayOfWeek ?? null;
            }
            // payload.forEach( slot => {
            //     const exists = state.slots.some( dbEvent => dbEvent.id === slot.id );
            //     if ( !exists ) {
            //         state.slots.push( slot )
            //     }
            // })

        },
        onDelete(state, { payload }) {

            state.slots = [];

        },



    },
});

export const { onReserve, onCreateSlot, onCheckingSlot, onDelete, onLoadSlots } = slotSlice.actions;

